export const AUTH_CONFIG = {
  microsoftTenantId: "9e2cb467-7238-480d-87c7-1564b4e4a8fc",
};

// 実際に関数をデプロイしたら変える
export const API_BASE_URL = "https://asia-northeast1-btob-production.cloudfunctions.net/eventCheckin";